import { render, staticRenderFns } from "./voicemail-note.vue?vue&type=template&id=37f7e7ff"
import script from "./voicemail-note.vue?vue&type=script&lang=js"
export * from "./voicemail-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports